import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import { navigate } from "../../../../service/navigation/Navigation";
import ShowToast from "../../../../widget/common/ui/Toast";
import {
  ChatListModel,
  ConversationList,
} from "../../../../model/chats/ChatListModel";
import {
  ChatTextType,
  MuteSettingsType,
} from "../../../../libraries/types_interface/chats/ChatsTypes";
import { GroupResults } from "../../../../model/chats/GroupConversationDetailsModel";
import { TeamResults } from "../../../../model/chats/TeamConversationDetailsModel";
import { DepartmentResults } from "../../../../model/chats/DepartmentConversationDetailsModel";
import SessionStorage from "../../../../service/storage/SessionStorage";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const ChatsProvider = new (class ChatsProvider {
  navigate = (url: any) => {
    navigate(url);
  };

  messageMaxLength = 210;

  muteSettingsDefault: MuteSettingsType = {
    muteStatus: "0",
    muteDuration: "",
    muteType: "0",
    muteEnd: "",
  };

  muteOptions: Record<string, string> = {
    for_15_minutes: "900",
    for_1_hour: "3600",
    for_1_week: "604800",
    until_i_turn_it_back_on: "0",
    un_mute: "-1",
  };

  updateMuteStatus = (
    tag: number,
    muteSettings: MuteSettingsType
  ): MuteSettingsType => {
    let muteSettingsInit: MuteSettingsType = muteSettings;

    switch (tag) {
      case 1: //15 mins
        muteSettingsInit = {
          ...muteSettings,
          muteDuration: "900",
          muteStatus: "1",
          muteType: "1",
        };
        break;
      case 2: // 1 hour
        muteSettingsInit = {
          ...muteSettings,
          muteDuration: "3600",
          muteStatus: "1",
          muteType: "1",
        };
        break;
      case 3: // 1 week
        muteSettingsInit = {
          ...muteSettings,
          muteDuration: "604800",
          muteStatus: "1",
          muteType: "1",
        };
        break;
      case 4: // always
        muteSettingsInit = {
          ...muteSettings,
          muteDuration: "0",
          muteStatus: "1",
          muteType: "2",
        };
        break;
      case 5: //unmute
        muteSettingsInit = {
          ...muteSettings,
          muteDuration: "0",
          muteStatus: "0",
          muteType: "0",
        };
        break;
    }

    return muteSettingsInit;
  };

  muteSettingValue = (duration: string): string => {
    let val: number = 4;
    if (duration === "900") {
      val = 1;
    } else if (duration === "3600") {
      val = 2;
    } else if (duration === "604800") {
      val = 3;
    } else if (duration === "0") {
      val = 4;
    } else if (duration === "-1") {
      val = 5;
    }
    return val.toString();
  };

  stopAllAudio = () => {
    console.log(`stopAllAudio`);
    const audios = document.querySelectorAll("audio");
    audios.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0; // reset to start
    });
  };

  identifyTextType(text: string): ChatTextType {
    const words = text.split(" ");

    for (const word of words) {
      let isAbsoluteUrl = false;

      try {
        const url = new URL(word);
        isAbsoluteUrl = Boolean(url.protocol && url.host);
      } catch {
        isAbsoluteUrl = false;
      }

      if (isAbsoluteUrl) {
        if (words.length === 1 && word === text) {
          return ChatTextType.url;
        }
        return ChatTextType.urlWithText;
      }
    }

    return ChatTextType.text;
  }

  getConversationsAPI = async (
    signal: AbortSignal
  ): Promise<Array<ConversationList> | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}conversation/get_conversation_list`;
    const body: any = {
      account_id: accountId,
    };

    const response: any = await ApiService.postApi(
      url,
      body,
      false,
      false,
      signal
    );
    if (response != null) {
      if (response["success"] === "1") {
        const chatListModel: ChatListModel = response;
        const conversationList: Array<ConversationList> =
          chatListModel?.result?.conversation_list!;
        return conversationList;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  reportChatAPI = async ({
    conversId,
    message,
  }: {
    conversId: string;
    message: string;
  }): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const branchId: string =
      CacheStorage.getValue(StorageKeys.branch_id) ?? "0";

    const url: string = `${ApiUrls.baseUrl}conversation/report_conversation`;

    const body: any = {
      account_id: accountId,
      conv_id: conversId,
      branch_id: branchId,
      reason: message.trim(),
    };

    console.log(body);
    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };

  setupChatConversationDetail = ({
    flag,
    detail,
  }: {
    flag: string; //"1" | "2" | "3"
    detail: TeamResults | DepartmentResults | GroupResults;
  }) => {
    if (["1", "2", "3"].includes(flag)) {
      SessionStorage.saveValue(
        StorageKeys.chats_conversation_detail,
        JSON.stringify(detail)
      );
    }
  };

  getChatConversationDetailSession = ():
    | null
    | TeamResults
    | DepartmentResults
    | GroupResults => {
    const chatsChatConversationSession = SessionStorage.getValue(
      StorageKeys.chats_conversation_detail
    );

    if (UtilityHelper.isNotEmpty(chatsChatConversationSession)) {
      const chatConverastion: ConversationList = JSON.parse(
        chatsChatConversationSession
      );

      return chatConverastion;
    }
    return null;
  };
})();

export default ChatsProvider;
